module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/5d1f9c06397eb3c8511b262cbeca5883.svg";